module.exports = __webpack_public_path__ + "static/img/mailinit.a2b9af0a.png";